/* eslint-disable @typescript-eslint/no-unused-vars */
import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppModuleGlobalShared } from '../../../app.module.global';
import { CoreModule } from '../../core/core.module';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { AccionesPerfilTipoEstadoService } from '../permisos/accionesperfiltipoestado/accionesperfiltipoestado.service';
import { AccionesPerfilTipoEstadoExService } from '../permisos/accionesperfiltipoestadoEx/accionesperfiltipoestadoEx.service';
import { DeclaracionSuplementariaEditComponent } from './declaracionessuplementarias/declaracionsuplementaria-edit/declaracionsuplementaria-edit.component';
import { DeclaracionSuplementariaFilterComponent } from './declaracionessuplementarias/declaracionsuplementaria-filter/declaracionsuplementaria-filter.component';
import { DeclaracionSuplementariaListComponent } from './declaracionessuplementarias/declaracionsuplementaria-list/declaracionsuplementaria-list.component';
import { DeclaracionSuplementariaWrapperEditComponent } from './declaracionessuplementarias/declaracionsuplementaria-wrapper-edit/declaracionsuplementaria-wrapper-edit.component';
import { DeclaracionSuplementariaWrapperComponent } from './declaracionessuplementarias/declaracionsuplementaria-wrapper/declaracionsuplementaria-wrapper.component';
import { DeclaracionSuplementariaService } from './declaracionessuplementarias/declaracionsuplementaria.service';
import { DestinoControlEditComponent } from './destinoscontrol/destinocontrol-edit.component';
import { DestinoControlListComponent } from './destinoscontrol/destinocontrol-list.component';
import { DestinoControlService } from './destinoscontrol/destinocontrol.service';
import { EmpresaDeshidratadoraService } from './empresasdeshidratadoras/empresadeshidratadora.service';
import { ErrorTracesEditComponent } from './errorestraces/errortraces-edit.component';
import { ErrorTracesListComponent } from './errorestraces/errortraces-list.component';
import { ErrorTracesService } from './errorestraces/errortraces.service';
import { InspectorExtrajeroEditComponent } from './inspectoresextranjeros/inspectorextranjero-edit.component';
import { InspectorExtrajeroListComponent } from './inspectoresextranjeros/inspectorextranjero-list.component';
import { InspectorExtranjeroService } from './inspectoresextranjeros/inspectorextranjero.service';
import { InstalacionAutorizadaEditComponent } from './instalacionesautorizadas/instalacionautorizada-edit.component';
import { InstalacionAutorizadaListComponent } from './instalacionesautorizadas/instalacionautorizada-list.component';
import { InstalacionAutorizadaService } from './instalacionesautorizadas/instalacionautorizada.service';
import { MrnEditComponent } from './mrns/mrn-edit.component';
import { MrnListComponent } from './mrns/mrn-list.component';
import { MrnService } from './mrns/mrn.service';
import { MunicipioEditComponent } from './municipios/municipios-edit.component';
import { MunicipioListComponent } from './municipios/municipios-list.component';
import { MunicipiosService } from './municipios/municipios.service';
import { NumeroSeguridadListComponent } from './numerosseguridad/numerosseguridad-list.component';
import { NumerosSeguridadService } from './numerosseguridad/numerosseguridad.service';
import { PaisEditComponent } from './paises/pais-edit.component';
import { PaisListComponent } from './paises/pais-list.component';
import { PaisService } from './paises/pais.service';
import { PuntoControlEditComponent } from './puntoscontrol/puntocontrol-edit.component';
import { PuntoControlListComponent } from './puntoscontrol/puntocontrol-list.component';
import { PuntoControlService } from './puntoscontrol/puntocontrol.service';
import { PuntoInspeccionService } from './puntosinspeccion/puntoinspeccion.service';
import { CargasSolicitudesPcfExService } from './cargassolicitudespcfex/cargassolicitudespcfex.service';
import { SolicitudEditComponent } from './solicitudes/solicitud-edit.component';
import { SolicitudListComponent } from './solicitudes/solicitud-list.component';
import { SolicitudService } from './solicitudes/solicitud.service';
import { SolicitudExListComponent } from './solicitudesex/solicitudesex-list/solicitudesex-list.component';
import { SolicitudesexWrapperEditComponent } from './solicitudesex/solicitudesex-wrapper-edit/solicitudesex-wrapper-edit.component';
import { SolicitudExService } from './solicitudesex/solicitudesex.service';
import { SolicitudesexEditComponent } from './solicitudesex/solicitudesex-edit/solicitudesex-edit.component';

import { TipoBultoEditComponent } from './tipobulto/tipobulto-edit.component';
import { TipoBultoListComponent } from './tipobulto/tipobulto-list.component';
import { TipoBultoService } from './tipobulto/tipobulto.service';
import { TipoDocumentacionEditComponent } from './tipodocumentacion/tipodocumentacion-edit.component';
import { TipoDocumentacionListComponent } from './tipodocumentacion/tipodocumentacion-list.component';
import { TipoDocumentacionService } from './tipodocumentacion/tipodocumentacion.service';
import { TipoDocumentacionExEditComponent } from './tipodocumentacionex/tipodocumentacionex-edit.component';
import { TipoDocumentacionExListComponent } from './tipodocumentacionex/tipodocumentacionex-list.component';
import { TipoDocumentacionExService } from './tipodocumentacionex/tipodocumentacionex.service';
import { TipoDocumentacionCamWrapperComponent } from '../general/tipodocumentacioncam/tipodocumentacioncam-wrapper/tipodocumentacioncam-wrapper.component';
import { TipoDocumentacionCamFilterComponent } from '../general/tipodocumentacioncam/tipodocumentacioncam-filter/tipodocumentacioncam-filter.component';
import { TipoDocumentacionCamListComponent } from '../general/tipodocumentacioncam/tipodocumentacioncam-list/tipodocumentacioncam-list.component';
import { TipoDocumentacionCamWrapperEditComponent } from '../general/tipodocumentacioncam/tipodocumentacioncam-wrapper-edit/tipodocumentacioncam-wrapper-edit.component';
import { TipoDocumentacionCamEditComponent } from '../general/tipodocumentacioncam/tipodocumentacioncam-edit/tipodocumentacioncam-edit.component';
import { TipoDocumentacionCamService } from '../general/tipodocumentacioncam/tipodocumentacioncam.service';
import { TrailblazerListComponent } from './trailblazer/trailblazer-list.component';
import { TrailblazerService } from './trailblazer/trailblazer.service';
import { TratamientoDesinfeccionEditComponent } from './tratamientodesinfeccion/tratamientodesinfeccion-edit/tratamientodesinfeccion-edit.component';
import { TratamientoDesinfeccionFilterComponent } from './tratamientodesinfeccion/tratamientodesinfeccion-filter/tratamientodesinfeccion-filter.component';
import { TratamientoDesinfeccionListComponent } from './tratamientodesinfeccion/tratamientodesinfeccion-list/tratamientodesinfeccion-list.component';
import { TratamientoDesinfeccionWrapperEditComponent } from './tratamientodesinfeccion/tratamientodesinfeccion-wrapper-edit/tratamientodesinfeccion-wrapper-edit.component';
import { TratamientoDesinfeccionWrapperComponent } from './tratamientodesinfeccion/tratamientodesinfeccion-wrapper/tratamientodesinfeccion-wrapper.component';
import { TratamientoDesinfeccionService } from './tratamientodesinfeccion/tratamientodesinfeccion.service';
import { UbicacionEditComponent } from './ubicaciones/ubicacion-edit.component';
import { UbicacionListComponent } from './ubicaciones/ubicacion-list.component';
import { UbicacionService } from './ubicaciones/ubicacion.service';
import { ComunesModule } from '../../_comunes/comunes.module';
import { PuntoInspeccionFilterComponent } from './puntosinspeccion/puntoinspeccion-filter/puntoinspeccion-filter.component';
import { PuntoInspeccionWrapperSearchComponent } from './puntosinspeccion/puntoinspeccion-wrapper-search/puntoinspeccion-wrapper-search.component';
import { PuntoInspeccionListComponent } from './puntosinspeccion/puntoinspeccion-list/puntoinspeccion-list.component';
import { PuntoInspeccionWrapperEditComponent } from './puntosinspeccion/puntoinspeccion-wrapper-edit/puntoinspeccion-wrapper-edit.component';
import { PorcentajeSemanalWrapperListEditComponent } from './puntosinspeccion/porcentajesemanal-wrapper-list-edit/porcentajesemanal-wrapper-list-edit.component';
import { PorcentajeSemanalListEditComponent } from './puntosinspeccion/porcentajesemanal-list-edit/porcentajesemanal-list-edit.component';
import { PuntoInspeccionEditComponent } from './puntosinspeccion/puntoinspeccion-edit/puntoinspeccion-edit.component';
import { PuntoInspeccionChildrenComponent } from './puntosinspeccion/puntoinspeccion-children/puntoinspeccion-children.component';
import { CargasSolicitudesPcfExFilterComponent } from './cargassolicitudespcfex/cargassolicitudespcfex-filter/cargassolicitudespcfex-filter.component';
import { CargasSolicitudesPcfExWrapperComponent } from './cargassolicitudespcfex/cargassolicitudespcfex-wrapper/cargassolicitudespcfex-wrapper.component';
import { CargasSolicitudesPcfExListComponent } from './cargassolicitudespcfex/cargassolicitudespcfex-list/cargassolicitudespcfex-list.component';
import { GeneralRoutingModule } from './general-routing.module';
import { AutoridadControlEditComponent } from './puntoscontrol/autoridadcontrol-edit.component';
import { EmpresaDeshidratadoraListComponent } from './empresasdeshidratadoras/empresadeshidratadora-list/empresadeshidratadora-list.component';
import { EmpresadeshidratadoraDetailDialogComponent } from './empresasdeshidratadoras/empresadeshidratadora-detail-dialog/empresadeshidratadora-detail-dialog.component';
import { EmpresaDeshidratadoraEditComponent } from './empresasdeshidratadoras/empresadeshidratadora-edit/empresadeshidratadora-edit.component';
import { EmpresadeshidratadoraFilterComponent } from './empresasdeshidratadoras/empresadeshidratadora-filter/empresadeshidratadora-filter.component';
import { EmpresadeshidratadoraListDialogComponent } from './empresasdeshidratadoras/empresadeshidratadora-list-dialog/empresadeshidratadora-list-dialog.component';
import { EmpresadeshidratadoraWrapperComponent } from './empresasdeshidratadoras/empresadeshidratadora-wrapper/empresadeshidratadora-wrapper.component';
import { TransicionEstadoUdInspeccionCamWrapperComponent } from './transicionestadosudsinspeccioncam/transicionestadoudinspeccioncam-wrapper/transicionestadoudinspeccioncam-wrapper.component';
import { TransicionEstadoUdInspeccionCamFilterComponent } from './transicionestadosudsinspeccioncam/transicionestadoudinspeccioncam-filter/transicionestadoudinspeccioncam-filter.component';
import { TransicionEstadoUdInspeccionCamListComponent } from './transicionestadosudsinspeccioncam/transicionestadoudinspeccioncam-list/transicionestadoudinspeccioncam-list.component';
import { TransicionEstadoUdInspeccionCamWrapperEditComponent } from './transicionestadosudsinspeccioncam/transicionestadoudinspeccioncam-wrapper-edit/transicionestadoudinspeccioncam-wrapper-edit.component';
import { TransicionEstadoUdInspeccionCamEditComponent } from './transicionestadosudsinspeccioncam/transicionestadoudinspeccioncam-edit/transicionestadoudinspeccioncam-edit.component';
import { TransicionEstadoUdInspeccionCamService } from './transicionestadosudsinspeccioncam/transicionestadoudinspeccioncam.service';
import { CertSedeExporSLListComponent } from './certificadosSedeExporSL/certSedeExporSL-list.component';
import { CertificadoSedeExporSlService } from './certificadosSedeExporSL/certSedeExporSL.service';

import { ComunidadAutonomaWrapperComponent } from './comunidadesautonomas/comunidadautonoma-wrapper/comunidadautonoma-wrapper.component';
import { ComunidadAutonomaFilterComponent } from './comunidadesautonomas/comunidadautonoma-filter/comunidadautonoma-filter.component';
import { ComunidadAutonomaService } from './comunidadesautonomas/comunidadautonoma.service';
import { ComunidadAutonomaListComponent } from './comunidadesautonomas/comunidadautonoma-list/comunidadautonoma-list.component';
import { ComunidadAutonomaEditComponent } from './comunidadesautonomas/comunidadautonoma-edit/comunidadautonoma-edit.component';
import { ComunidadAutonomaWrapperEditComponent } from './comunidadesautonomas/comunidadautonoma-wrapper-edit/comunidadautonoma-wrapper-edit.component';
import { EmpresaDeshidratadoraDesautorizadaCamService } from './empresasdeshidratadoras/empresadeshidratadora-desautorizada-cam.service';

@NgModule({
    declarations: [
        TrailblazerListComponent,
        PuntoInspeccionChildrenComponent,
        PuntoInspeccionFilterComponent,
        PuntoInspeccionListComponent,
        PuntoInspeccionWrapperSearchComponent,
        PuntoInspeccionEditComponent,
        PuntoInspeccionWrapperEditComponent,
        PorcentajeSemanalListEditComponent,
        PorcentajeSemanalWrapperListEditComponent,
        CargasSolicitudesPcfExWrapperComponent,
        CargasSolicitudesPcfExListComponent,
        CargasSolicitudesPcfExFilterComponent,
        PaisListComponent,
        PaisEditComponent,
        SolicitudListComponent,
        SolicitudEditComponent,

        SolicitudExListComponent,
        SolicitudesexWrapperEditComponent,
        SolicitudesexEditComponent,

        TipoBultoListComponent,
        TipoBultoEditComponent,
        SolicitudExListComponent,

        MrnListComponent,
        MrnEditComponent,

        PuntoControlListComponent,
        PuntoControlEditComponent,
        DestinoControlListComponent,
        DestinoControlEditComponent,
        InstalacionAutorizadaListComponent,
        InstalacionAutorizadaEditComponent,
        InspectorExtrajeroEditComponent,
        InspectorExtrajeroListComponent,
        MunicipioListComponent,
        MunicipioEditComponent,
        NumeroSeguridadListComponent,
        ErrorTracesEditComponent,
        ErrorTracesListComponent,

        UbicacionListComponent,
        UbicacionEditComponent,
        TipoDocumentacionListComponent,
        TipoDocumentacionEditComponent,
        TipoDocumentacionExListComponent,
        TipoDocumentacionExEditComponent,
        TipoDocumentacionCamWrapperComponent,
        TipoDocumentacionCamFilterComponent,
        TipoDocumentacionCamListComponent,
        TipoDocumentacionCamWrapperEditComponent,
        TipoDocumentacionCamEditComponent,
        EmpresaDeshidratadoraListComponent,
        EmpresaDeshidratadoraEditComponent,

        DeclaracionSuplementariaListComponent,
        DeclaracionSuplementariaWrapperComponent,
        DeclaracionSuplementariaFilterComponent,
        DeclaracionSuplementariaEditComponent,
        DeclaracionSuplementariaWrapperEditComponent,

        TratamientoDesinfeccionFilterComponent,
        TratamientoDesinfeccionListComponent,
        TratamientoDesinfeccionWrapperEditComponent,
        TratamientoDesinfeccionWrapperComponent,
        TratamientoDesinfeccionEditComponent,
        AutoridadControlEditComponent,

        EmpresadeshidratadoraWrapperComponent,
        EmpresadeshidratadoraFilterComponent,
        EmpresadeshidratadoraListDialogComponent,
        EmpresadeshidratadoraDetailDialogComponent,

        TransicionEstadoUdInspeccionCamWrapperComponent,
        TransicionEstadoUdInspeccionCamFilterComponent,
        TransicionEstadoUdInspeccionCamListComponent,
        TransicionEstadoUdInspeccionCamWrapperEditComponent,
        TransicionEstadoUdInspeccionCamEditComponent,

        CertSedeExporSLListComponent,

        /*Mantenimiento ccaa*/
        ComunidadAutonomaWrapperComponent,
        ComunidadAutonomaFilterComponent,
        ComunidadAutonomaListComponent,
        ComunidadAutonomaEditComponent,
        ComunidadAutonomaWrapperEditComponent,
    ],
    imports: [CoreModule, ComunesModule, AppModuleGlobalShared, CommonModule, FormsModule, ReactiveFormsModule, GeneralRoutingModule, ToggleButtonModule],
    providers: [
        TrailblazerService,
        PuntoInspeccionService,
        PaisService,
        TipoBultoService,
        MrnService,
        SolicitudService,
        SolicitudExService,
        InspectorExtranjeroService,
        AccionesPerfilTipoEstadoService,
        AccionesPerfilTipoEstadoExService,
        PuntoControlService,
        CargasSolicitudesPcfExService,
        DestinoControlService,
        InstalacionAutorizadaService,
        DatePipe,
        DecimalPipe,
        MunicipiosService,
        NumerosSeguridadService,
        ErrorTracesService,
        UbicacionService,
        TipoDocumentacionService,
        TipoDocumentacionExService,
        TipoDocumentacionCamService,
        EmpresaDeshidratadoraService,
        DeclaracionSuplementariaService,
        TratamientoDesinfeccionService,
        TransicionEstadoUdInspeccionCamService,
        CertificadoSedeExporSlService,
        ComunidadAutonomaService,
        EmpresaDeshidratadoraDesautorizadaCamService,
    ],
    exports: [
        EmpresaDeshidratadoraListComponent,
        EmpresaDeshidratadoraEditComponent,
        EmpresadeshidratadoraDetailDialogComponent,
        EmpresadeshidratadoraListDialogComponent,
    ],
})
export class GeneralModule {}
